module.exports = __webpack_public_path__ + "img/flex_jeans.c36e5e25.jpg";